export default function RatingStars({
  rating,
  size = "text-sm",
}: {
  rating: number;
  size?: string;
}) {
  const stars = rating / 2;
  return (
    <span className={`flex items-center gap-0.5 text-accent-500 ${size}`} aria-hidden="true">
      {[0, 1, 2, 3, 4].map((index) => {
        const diff = stars - index;
        const icon =
          diff >= 1 ? "ri-star-fill" : diff >= 0.5 ? "ri-star-half-fill" : "ri-star-line";
        return <i key={index} className={icon}></i>;
      })}
    </span>
  );
}